export const purposes = {
  1: "Alugar",
  2: "Comprar",
  3: "Alugar ou Comprar",
} as const

export const purposesRO = { ...purposes }

export type TPurpose = typeof purposes
